<template>    
   <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <button class="modal__buttons__item ml-0 mt-3" v-html="`See permissions`" type="button" @click="$emit('seePermissionsFromModal', global_index)"/>
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />

                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'rest_api',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        'array_options',
        'breadcrumb',
        'associates_selected',
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:       FormResources.form_main_format,
            form_format2:      FormResources.form_format2,
            associates_roles:  [],
            associate_counter: 0,
        }
    },
    
    methods:{
        changeValidationReportsTo(param)
        {
            this.form_format[10].disabled = !param
            this.form_format[10].required = param

            this.form_format[10].disabled = param
            this.form_format[10].required = !param
        },

        refresh()
        {
            this.displayReportsTo(this.single_object.role_id)
            setTimeout(() => {
                this.getAssociatedFacilities()
            }, 100);
        },

        async displayReportsTo(val)
        {
            if(val)
            {
                this.loader(true)
                
                const response = await this.post('reports_to_by_roles', {rol: val, id: this.single_object.id})

                if(response.status)
                {
                    this.array_options.report_associate_id = response.data.associates

                    if(response.data.should_report)
                    {
                        this.changeValidationReportsTo(false)

                        let found_associate =  this.array_options['report_associate_id'].findIndex(item => item.id === this.single_object.report_associate_id)

                        if(found_associate < 0)
                        {
                            this.single_object.report_associate_id = ''
                        }
                    }
                    else
                    {
                        this.changeValidationReportsTo(true)
                        this.single_object.report_associate_id = ''
                    }
                }

                this.loader()
            }
        },

        async getAssociatedFacilities()
        { 
            const response = await this.get(`associates/get_associated_facilities/${this.single_object.user_id}`)

            if(response.status)
            {
                this.single_object = {...this.single_object, give_access_to: response.data.facilities_associate};
            }

            this.loader()
        }

    },

    mounted(){

    },

    watch: {
        async "single_object.role_id"(val)
        {
            await this.displayReportsTo(val)
        }
    }
    
}
</script>